<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QMUNxP/tc-custom/9781524860295.jpg?1720280500469" alt="This image is the cover for the book Mary Mac's Tea Room 75th Anniversary Cookbook"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mary Mac's Tea Room 75th Anniversary Cookbook
      </h1>
      <p class="bookDescription body article font2">
        <b>The renowned Atlanta eatery shares its traditional Southern comfort food recipes—plus stories, photos, and memorabilia from its seventy-five-year history.</b><br/><br/>In 1945, Mary Mac’s Tea Room opened in Atlanta, Georgia. Serving more than just tea, it began as a nicer version of the traditional “meat and three.” For folks who had moved to Atlanta from Georgia’s small towns, its upscale comfort food reminded them of home. Seventy-five years later, Mary Mac’s continues to bring great Southern cooking to everyone from blue collar workers to celebrities. <br/><br/>Now you can bring the restaurant’s famous home cooking to your own home with this richly illustrated volume. More than just a collection of recipes, it also shares the restaurant’s rich history through stories of family, friends, employees, and loyal customers, as well as photos, old menus, postcards, and more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Ferrell
      </h2>
      
      <p class="authorDescription body article">John Ferrell is the current owner of Mary Mac's Tea Room. He purchased the restaurant in 1994 from Margaret Lup, who ran it for more than thirty years. He lives in Atlanta.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6bdf9496